export function scrollToElement(id: string) {
    if (!id) return;

    let attempts = 0;
    const maxAttempts = 30;
    const interval = 200;
    const offset = 200; // Adjust this based on your navbar height

    const tryScroll = () => {
        const allElements = Array.from(document.querySelectorAll<HTMLElement>('[id]'));
        let targetElement: HTMLElement | null = null;

        for (let el of allElements) {
            if (el.id.toLowerCase() === id.toLowerCase()) {
                targetElement = el;
                break;
            }
        }

        if (targetElement && targetElement.offsetHeight > 0) {
            requestAnimationFrame(() => {
                const targetTop = targetElement!.getBoundingClientRect().top + window.scrollY;

                // If it's the "feature" section, apply offset
                const scrollToY = id.toLowerCase() === "featured"
                    ? targetTop - offset
                    : targetTop;

                window.scrollTo({ top: scrollToY, behavior: "smooth" });
            });
        } else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(tryScroll, interval);
        } else {
            console.warn(`[scrollToElement] Element with ID '${id}' (case-insensitive) not found after ${maxAttempts} attempts.`);
        }
    };

    tryScroll();
}
